import { useState, useEffect } from "react";
import { Menu, X, Sparkles } from "lucide-react";

const NAV = [
  { id: "hero", label: "Home" },
  { id: "servizi", label: "Servizi" },
  { id: "servizi", label: "Prezzi", key: "prezzi" },
  { id: "prenota", label: "Prenota" },
  { id: "aziende", label: "Aziende" },
  { id: "recensioni", label: "Recensioni" },
  { id: "contatti", label: "Contatti" },
];

export const Header = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    onNavigate(id);
  };

  return (
    <header
      data-testid="header-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "glass py-2 shadow-2xl" : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between">
        <button
          data-testid="logo-brand"
          onClick={() => go("hero")}
          className="flex items-center gap-3 group"
        >
          <img
            src="/logo.png"
            alt="Cosimiroclean logo"
            className="h-11 w-auto drop-shadow-[0_0_12px_rgba(126,200,227,0.35)] transition-transform group-hover:scale-105"
          />
          <span className="hidden sm:flex flex-col leading-none">
            <span className="font-display font-extrabold tracking-wide text-metallic text-lg">
              COSIMIROCLEAN
            </span>
            <span className="text-[10px] tracking-[0.35em] text-[#7EC8E3]">
              DETAILING AUTO
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.key || n.id}
              data-testid={`nav-link-${n.key || n.id}`}
              onClick={() => go(n.id)}
              className="text-sm font-medium text-slate-300 hover:text-[#A0E0FF] transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-[#7EC8E3] after:transition-all hover:after:w-full"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-cta-prenota"
            onClick={() => go("prenota")}
            className="hidden sm:inline-flex btn-silver rounded-full px-5 py-2.5 text-sm items-center gap-2"
          >
            <Sparkles size={16} /> Prenota ora
          </button>
          <button
            className="md:hidden text-slate-200"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden glass mt-2 mx-3 rounded-2xl p-4 flex flex-col gap-1" data-testid="mobile-menu">
          {NAV.map((n) => (
            <button
              key={n.key || n.id}
              onClick={() => go(n.id)}
              className="text-left px-3 py-3 rounded-lg text-slate-200 hover:bg-white/5 hover:text-[#A0E0FF] transition-colors"
            >
              {n.label}
            </button>
          ))}
          <button
            onClick={() => go("prenota")}
            className="btn-silver rounded-full px-5 py-3 mt-2 text-sm"
          >
            Prenota ora
          </button>
        </div>
      )}
    </header>
  );
};
